import { useState } from "react";
import toast from "react-hot-toast";
import { ValidatorHelper } from "../../../core/helpers/validator_helper";
import { RegisterLeadsModel } from "../data/model/register_leads_model";
import RegisterLeadsEntity from "../domain/entities/register_leads_entity";

const initialState = {
    name: "",
    email: "",
    message: "",
};

const initialErrors = {
    name: null,
    email: null,
    message: null,
};

export const useContactViewModel = () => {
    const [form, setForm] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isLoading, setIsLoading] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");

    const handleChange = (fieldName, value) => {
        setForm((prev) => ({ ...prev, [fieldName]: value }));
        if (errors[fieldName]) setErrors((prev) => ({ ...prev, [fieldName]: null }));
        setSubmitError(null);
    };

    const handleCaptchaSuccess = (token) => {
        setCaptchaToken(token);
    };

    const handleCaptchaExpire = () => {
        setCaptchaToken("");
    };

    const handleCaptchaError = () => {
        setCaptchaToken("");
        toast.error("Erro ao carregar o captcha. Recarregue a página.");
    };

    const handleSubmit = async (event) => {
        try {
            event.preventDefault();

            const nameError = ValidatorHelper.name(form.name);
            const emailError = ValidatorHelper.email(form.email);
            const messageError = ValidatorHelper.message(form.message);

            setErrors({
                name: nameError,
                email: emailError,
                message: messageError,
            });

            const hasErrors = nameError || emailError || messageError;

            if (hasErrors) return;

            if (!captchaToken) {
                toast.error("Por favor, complete a verificação de segurança.");
                return;
            }

            setIsLoading(true);
            setSubmitError(null);
            setSubmitSuccess(false);

            await new Promise((resolve) => setTimeout(resolve, 1000));

            const leadsEntity = new RegisterLeadsEntity(
                form.name,
                form.email,
                form.message,
                captchaToken
            );
            await RegisterLeadsModel.submitLead(leadsEntity);

            setSubmitSuccess(true);
            setForm(initialState);
            setCaptchaToken("");
            toast.success("Mensagem enviada com sucesso!");
        } catch (err) {
            const message = err?.message ?? "Não foi possível enviar. Tente novamente.";
            setSubmitError(message);
            toast.error(message);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        form,
        errors,
        isLoading,
        submitError,
        submitSuccess,
        captchaToken,
        handleChange,
        handleSubmit,
        handleCaptchaSuccess,
        handleCaptchaExpire,
        handleCaptchaError,
    };
};
